import { useUpdateTeamMutation } from 'src/api/redux/teams';

interface UpdateTeamData {
  id?: string;
  name: string;
  description: string;
  users: string[];
  filter_set_folders?: string[];
  plays_enabled?: boolean;
}

export const useUpdateTeam = () => {
  const [updateTeamMutation, { isLoading: isUpdating, error }] =
    useUpdateTeamMutation();

  const handleUpdateTeam = async (id: string, data: UpdateTeamData) => {
    try {
      // Use the id parameter, ignore data.id if present
      const result = await updateTeamMutation({
        id,
        name: data.name,
        description: data.description,
        users: data.users,
        plays_enabled: data.plays_enabled,
      }).unwrap();
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err };
    }
  };

  return {
    updateTeam: handleUpdateTeam,
    isUpdating,
    error: error
      ? {
          message:
            (error as { data?: { detail?: string } })?.data?.detail ||
            'An error occurred',
        }
      : null,
  };
};

export default useUpdateTeam;
